import client from './client';
import type { RegionConfig } from '../types';

export const listRegions = () =>
  client.get<RegionConfig[]>('/api/regions');

export const updateRegion = (id: number, body: { domains?: string[]; ips?: string[] }) =>
  client.put<{ status: string }>(`/api/regions/${id}`, body);

// Combined region bundle: name + domains + IPs + game-server list.
// regions / region_servers tables are populated by `go run ./cmd/seedregions`
// at deploy time; the /region-lines (now /大区) page just reads from DB.
export interface RegionServer {
  server_id: number;
  server_name: string;
  current_connections: number;
  max_observed_connections: number;
}
export interface RegionBundle {
  region_id: number;
  region_name: string;
  domains: string[];
  ip_count: number;
  ips: string[];
  game_ip_count: number;
  game_ips: string[];
  servers: RegionServer[];
}
export const listRegionServers = () =>
  client.get<RegionBundle[]>('/api/region-servers');

// syncRegions re-resolves DNS for every region, probes sessiond for the
// game-server list, and pushes update_allowed_ips to active proxies if
// IPs changed. The response enumerates per-region diffs.
export interface PerRegionSyncResult {
  region_id: number;
  region_name: string;
  ip_changed: boolean;
  added_ips: string[];
  removed_ips: string[];
  server_changed: boolean;
  added_servers: { server_id: number; server_name: string }[];
  removed_servers: { server_id: number; server_name: string }[];
  updated_servers: { server_id: number; server_name: string }[];
  skipped: string;
}
export interface SyncRegionsResponse {
  synced_count: number;
  changed_count: number;
  results: PerRegionSyncResult[];
}
export const syncRegions = () =>
  client.post<SyncRegionsResponse>('/api/regions/sync');
